export const ChannelOperationType = {
    PUBLISHER: 'PUBLISHER',
    SUBSCRIBER: 'SUBSCRIBER',
};
export const ChannelEventConstant = {
    CHANNEL_FETCH_STARTED: 'CHANNEL_FETCH_STARTED',
    CHANNEL_FETCH_FAILED: 'CHANNEL_FETCH_FAILED',
    CHANNEL_FETCH_SUCCESS: 'CHANNEL_FETCH_SUCCESS',
    CHANNEL_STATUS_CONNECTED: 'CHANNEL_STATUS_CONNECTED',
    CHANNEL_STATUS_RECONNECTING: 'CHANNEL_STATUS_RECONNECTING',
    CHANNEL_STATUS_RECONNECTED: 'CHANNEL_STATUS_RECONNECTED',
    CHANNEL_STATUS_FAILED: 'CQM_CHANNEL_STATUS_FAILED',
    CHANNEL_INIT_FAILED: 'CHANNEL_INIT_FAILED',
    CHANNEL_PUBLISH_CALLED_BEFORE_INIT: 'CHANNEL_PUBLISH_CALLED_BEFORE_INIT',
    CHANNEL_GOT_STATUS_EVENT: 'CHANNEL_GOT_STATUS_EVENT',
    CHANNEL_RECONNECTION_TIMEOUT: 'CHANNEL_RECONNECTION_TIMEOUT',
    CHANNEL_TIMETOKEN_FETCH_FAILED: 'CHANNEL_TIMETOKEN_FETCH_FAILED',
};
export const CueMessageBrokerEvents = {
    CHANNEL_INIT_FAILED: 'CHANNEL_INIT_FAILED',
};
export const PublisherEventConstants = {
    PUBLISH_POST_FAILED: 'PUBLISH_POST_FAILED',
    PUBLISH_POST_STARTED: 'PUBLISH_POST_STARTED',
    PUBLISH_POST_SUCCESS: 'PUBLISH_POST_SUCCESS',
    PUBLISH_ATTEMPT_AFTER_RECONNECT: 'PUBLISH_ATTEMPT_AFTER_RECONNECT',
    PUBLISH_ATTEMPTED_WHILE_IN_PROCESS: 'PUBLISH_ATTEMPTED_WHILE_IN_PROCESS',
    PUBLISH_MESSAGE_OVER_MAX_SIZE: 'PUBLISH_MESSAGE_OVER_MAX_SIZE',
};
export const SubscriberEventConstants = {
    SUBSCRIBER_MESSAGE_RECIVED: 'SUBSCRIBER_MESSAGE_RECIVED',
    SUBSCRIBER_OUT_OF_SEQ_MESSAGE: 'SUBSCRIBER_OUT_OF_SEQ_MESSAGE',
    SUBSCRIBER_OUT_SEQ_FETCH_STARTED: 'SUBSCRIBER_OUT_SEQ_FETCH_STARTED',
    SUBSCRIBER_OUT_SEQ_FETCH_SUCCESS: 'SUBSCRIBER_OUT_SEQ_FETCH_SUCCESS',
    SUBSCRIBER_OUT_SEQ_FETCH_FAILED: 'SUBSCRIBER_OUT_SEQ_FETCH_FAILED',
    SUBSCRIBER_GOT_SEQ_AFTER_FETCH: 'SUBSCRIBER_GOT_SEQ_AFTER_FETCH',
    SUBSCRIBER_RETRY_FAILED: 'SUBSCRIBER_RETRY_FAILED',
    SUBSCRIBER_MESSAGE_UUID_ABSENT: 'SUBSCRIBER_MESSAGE_UUID_ABSENT',
};
//# sourceMappingURL=event-constants.js.map